<template>
  <v-icon :large="large">{{ icon }}</v-icon>
</template>

<script>
import { MenuTypes } from '@/models/Menu/Constants'

export default {
  name: 'AppMenuIcon',
  props: {
    large: {
      type: Boolean,
      default: false,
    },
    menuType: {
      type: String,
      default: '',
    },
  },
  computed: {
    icon() {
      switch (this.menuType) {
        case MenuTypes.Geo:
          return 'location_on'
        case MenuTypes.Pta:
          return 'mdi-human-male-boy'
        case MenuTypes.Mansion:
          return 'apartment'
        case MenuTypes.Newspaper:
          return 'local_library'
        case MenuTypes.Automobile:
          return 'directions_car'
        case MenuTypes.GeoGenome:
          return 'home'
        case MenuTypes.Railway:
          return 'train'
        case MenuTypes.Retargeting:
          return 'mdi-run'
        case MenuTypes.Custom:
          return 'settings'
        case MenuTypes.Office:
          return 'business'
        case MenuTypes.CustomGeo:
          return 'where_to_vote'
        default:
          return ''
      }
    },
  },
}
</script>
